module.exports = __webpack_public_path__ + "media/spring_tip_2-d10fb9224cd5e22d7c2750573da54069.mp3";